module.exports = __webpack_public_path__ + "static/media/bharat.2601f4d3.jpg";